import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";

const PageViewsSetting = ({ pageViewPayload }) => {
    const { register, handleSubmit } = useForm();

    
    const onSubmit = (formData) => {
        pageViewPayload({
            pvPayload:formData
        });
    };

    // console.log(data);

    return (
        <>
            <div style={{ background: "#f5f5f5", padding: "25px" }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <h5 style={{ color: "#007bff" }}>Page Views Setting</h5>

                    <Form.Group className="mt-4">
                        <Form.Label>PV Count By</Form.Label>
                        <Form.Select
                            {...register("pageViewsCount")}>
                            <option value="0">Ad Request</option>
                            <option value="1">Impression</option>
                        </Form.Select>

                        <Form.Label>Type</Form.Label>
                        <Form.Select
                            {...register("pageViewsType")}>
                            <option value="0">Display</option>
                            <option value="1">Video</option>
                        </Form.Select>

                        <Form.Label>Status</Form.Label>
                        <Form.Select
                            {...register("pageViewsStatus")}>
                            <option value="1">Active</option>
                            <option value="5">Pending</option>

                        </Form.Select>
                    </Form.Group>

                    <input className="mt-4 btn btn-primary" type="submit" value="Submit" />

                </form>
            </div>
        </>
    )
}
export default PageViewsSetting;